import useTasks from '@modules/TasksModule/hooks/useTasks';
import { Banner } from '@servicetitan/design-system';
import CustomerSearch from '../CustomerSearch';
import styles from './TaskCustomerSearchView.module.css';
import strings from '../strings';
import { useSystemCustomerSearch } from '../useSystemCustomerSearch';
import { useCustomerSearchContext } from '../context';
import useVoiceTask from '@modules/TasksModule/hooks/useVoiceTask';

interface TaskCustomerSearchProps {
  taskId: string;
  tenantId: string | undefined;
}

export const TaskCustomerSearchView = ({
  taskId,
  tenantId,
}: TaskCustomerSearchProps) => {
  const { taskById } = useTasks();
  const task = taskById[taskId];
  const { setSearchParams, onSelectCustomer, search } =
    useCustomerSearchContext();

  const { isSystemCustomerNotFound } = useSystemCustomerSearch({
    task,
    tenantId,
    onSelectCustomer,
    setSearchParams,
    search,
  });

  const { isInternal } = useVoiceTask(task);

  return (
    <>
      {isSystemCustomerNotFound && (
        <Banner
          className={styles.warningBanner}
          status='warning'
          title={strings.warnings.systemCustomerNotFound}
        />
      )}
      <CustomerSearch
        tenantId={task.tenantId}
        onSelectCustomer={onSelectCustomer}
        isSearchOnLoad={!isSystemCustomerNotFound && !isInternal}
      />
    </>
  );
};
